module.exports = __webpack_public_path__ + "media/images/icons/country_flags/de-adc6c9b3594fb2f4a4df9a9cea56a1ab.svg";